import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { LanguageService } from './language.service';
import { StorageService } from './storage.service';
import { Formats } from '../_config/formats';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TranslationSet {
  public languange: string;
  public values: { [key: string]: string } = {};
}

@Injectable()
export class LanguageManagerService {
  private currentLanguageKey = 'CurrentLanguage';
  private languageSuscription$!: Subscription;
  public languageChanged$ = new BehaviorSubject<string>('');
  public languagesDownloaded$ = new BehaviorSubject<string[]>([]);
  public languageManagerReady$ = new Subject<boolean>();
  public language = 'es-ES';
  public languages: string[] = [];
  public dateAndCurrencyChangeFormat$ = new Subject<any>();

  private connectionErrorSuscription$!: Subscription;
  public connectionError$ = new Subject<any>();

  private languagesDictionary: any = null;

  userLang = navigator.language;

  constructor(
    private languageService: LanguageService,
    private storageService: StorageService,
    private titleService: Title,
  ) {
    // enganchamos el evento de connection error desde language service para devolverlo
    this.connectionErrorSuscription$ = 
    this.languageService.connectionError$.subscribe((error)=>{
      this.connectionError$.next(error);
    })
    this.languageSuscription$ =
      this.languageService.languagesDownloaded$.subscribe((dictionary) => {
        this.SetLanguageDictionary(dictionary);
        this.SetLanguageDefault();
      });
    this.GetLanguagesDictionaryWithCache();
  }
  GetDefaultLanguage() {
    let currentLanguage = this.storageService.get(this.currentLanguageKey);
    if (currentLanguage != null) {
      return currentLanguage;
    }
    var userLangAux = this.userLang;
    if (userLangAux.toLocaleLowerCase().includes('es')) {
      return 'es-ES';
    } else if (userLangAux.toLocaleLowerCase().includes('de')) {
      return 'de-DE';
    } else if (userLangAux.toLocaleLowerCase().includes('pt')) {
      return 'pt-PT';
    } else if (userLangAux.toLocaleLowerCase().includes('en')) {
      return 'en-GB';
    } else {
      return 'es-ES';
    }
  }

  TranslateTitle(title: string) {
    if (title.startsWith('title_')) {
      this.titleService.setTitle(this.translate(title.replace('title_', '')));
    }
  }

  SetLanguageDefault() {
    this.SetLanguage(this.GetDefaultLanguage());
  }
  async GetLanguagesDictionaryWithCache() {
    await this.languageService.Languages_Get();
    return;
  }
  SetLanguageDictionary(dictionary: { [key: string]: any }) {
    this.languages = Object.keys(dictionary);
    this.languagesDownloaded$.next(this.languages);
    this.languagesDictionary = dictionary;
    this.languageManagerReady$.next(true);
  }

  SetLanguage(lang: any) {
    this.storageService.set(this.currentLanguageKey, lang);
    this.language = lang;
    this.emitLangChange(lang);
    this.updateFormats(lang);
  }

  translate(key: string): string {
    return this.translateItemFromDictionary(key).replaceAll(/\{entidad\}/gi,environment.entity);
  }
  translateItemFromDictionary(key: string): string {
    if (!key) return '';
    key = key.trimEnd().toLowerCase();
    // if key does not have translate format, we return the key
    if (!(key.includes('.') && key.includes('_'))) {
      return key;
    }
    let dictionary = this.languagesDictionary;
    if (dictionary == null) {
      return '';
    }
    if (
      dictionary != undefined && // si hay idiomas
      dictionary[this.language] != null && // si el idioma seleccionado esta entre los idiomas
      dictionary[this.language][key] != undefined &&
      key.startsWith('@@')
    ) {
      key = key.replace('@@', '');
    }
    if (
      dictionary != undefined && // si hay idiomas
      dictionary[this.language] != null && // si el idioma seleccionado esta entre los idiomas
      dictionary[this.language]['@@' + key] != undefined // si la clave esta
    ) {
      return dictionary[this.language]['@@' + key];
    } else {
      if (!environment.production) {
        return '.' + this.language + '-' + key;
      }
      return key;
    }
  }

  emitLangChange(val) {
    this.languageChanged$.next(val);
  }

  // Actualizar los formatos y emitir los nuevos valores
  updateFormats(lang: string) {
    const formats = {
      date: Formats.date[lang] || Formats.date['es-ES'],
      currency: Formats.currency[lang] || Formats.currency['EUR'],
    };
    this.dateAndCurrencyChangeFormat$.next(formats); // Emitimos los nuevos formatos
  }

  // Recuperamos el idioma actual o 'es-ES' por defecto
  GetCurrentLanguage() {
    return this.storageService.get(this.currentLanguageKey) || 'es-ES';
  }
}
